export default "/images/crypto_environments/ethereum_audit_2.png";